const LIGHT_THEME = 'docuseal'
const DARK_THEME = 'docuseal_dark'

const applyTheme = (theme) => {
  const nextTheme = theme === DARK_THEME ? DARK_THEME : LIGHT_THEME
  const isDark = nextTheme === DARK_THEME
  const root = document.documentElement

  root.setAttribute('data-theme', nextTheme)
  root.classList.toggle('dark', isDark)
  document.body?.setAttribute('data-current-theme', nextTheme)

  const metaTheme = document.querySelector('meta[name="theme-color"]')

  if (metaTheme) {
    metaTheme.setAttribute('content', isDark ? '#0f172a' : '#faf7f5')
  }

  document.querySelectorAll('[data-theme-toggle-input]').forEach((el) => {
    el.checked = isDark
  })

  document.querySelectorAll('[data-theme-toggle]').forEach((el) => {
    el.setAttribute('aria-pressed', String(isDark))
  })

  return nextTheme
}

export const isDarkTheme = () => document.documentElement.getAttribute('data-theme') === DARK_THEME

export const getThemeSurface = () => (isDarkTheme() ? '#0f172a' : '#faf7f5')

// Turbo replaces only <head>/<body> on a soft navigation, so data-theme and
// .dark on <html> would keep the value of the previous document (this is why
// signing in no longer applied the account's dark theme until a hard reload).
// The body carries the theme of the document just rendered, which is what to
// re-apply on every navigation. It is a separate attribute because data-theme
// itself drives the DaisyUI variables.
const documentTheme = () => {
  const theme = document.body?.dataset?.currentTheme || document.documentElement.getAttribute('data-theme')

  return theme === DARK_THEME ? DARK_THEME : LIGHT_THEME
}

export const initTheme = () => {
  applyTheme(documentTheme())

  document.addEventListener('turbo:load', () => applyTheme(documentTheme()))

  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-theme-toggle]')

    if (!toggle) return

    event.preventDefault()

    const nextTheme = isDarkTheme() ? LIGHT_THEME : DARK_THEME
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content

    applyTheme(nextTheme)

    if (!csrfToken) return

    fetch('/account_configs', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken
      },
      body: JSON.stringify({
        account_config: {
          key: 'theme',
          value: nextTheme === DARK_THEME ? 'dark' : 'light'
        }
      })
    }).catch(() => {})
  })
}
